module.exports = __webpack_public_path__ + "img/ai.dd56d03.svg";